import { render, staticRenderFns } from "./SkinSelector.vue?vue&type=template&id=e648a95e&"
import script from "./SkinSelector.vue?vue&type=script&lang=js&"
export * from "./SkinSelector.vue?vue&type=script&lang=js&"
import style0 from "./SkinSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports